<template>
    <tr class="main-content" :class="{'is-visited': isVisited, 'has-bid': hasEnquiry}">
        <td class="picture-td" data-label="photo">
            <figure class="image is-65x65" @click="openGallery">
                <img :src="lot.images + '&w=320'" @error="imgUrlAlt($event)">
            </figure>
        </td>
        <td class="link" @click="goToLotSinglePage" data-label="Date/Time">
            {{ lot.auct_date.split(' ')[0] }}<br>
            {{ lot.auct_date.split(' ')[1] }}
        </td>
        <td class="link" @click="goToLotSinglePage" data-label="Place/Lot #">
            {{ lot.auct_name }}<br>
            {{ lot.lot_num }}
        </td>
        <td @click="goToLotSinglePage" data-label="Model/Grade">
            {{ lot.manuf_name }} {{ lot.model_name }}<br>
            <span v-html="lot.grade"></span>
        </td>
        <td @click="goToLotSinglePage" data-label="Year">
            {{ lot.year }}
        </td>
        <td @click="goToLotSinglePage" data-label="Chassis/Engine">
            <span v-html="lot.body"></span><br>
            <span v-html="lot.Vcc"></span>
        </td>
        <td @click="goToLotSinglePage" data-label="Mileage/TM">
            {{ lot.mileage | formatNumber }} km<br>
            {{ lot.transmission }}
        </td>
        <td @click="goToLotSinglePage" data-label="Color/Score">
            {{ lot.colour }}<br>
            {{ lot.rate }}
        </td>
        <td data-label="Start Price">
            <span>{{ lot.price_start | formatNumber }}</span>
        </td>
        <td data-label="Action">
            <button class="button is-small is-primary enquiry has-tooltip-primary" data-tooltip="Do you want to pay lesser for this car? let us know how much!" @click="counterOffer">Counter-offer</button>
            <button class="button is-small is-danger enquiry" @click="enquiry">Enquiry</button>
        </td>
    </tr>
</template>

<script>
    export default {
        props:['lot', 'index', 'user'],
        methods: {
            goToLotSinglePage() {
                this.$store.dispatch('setLotToIsVisitedStock', this.lot.lot_id)
                this.$router.push({
                    path: '/buy-now/' + this.lot.lot_id,
                })
            },
            imgUrlAlt(event){
                event.target.src = '/static/images/hero-4.jpeg'
            },
            enquiry(){
                this.$store.dispatch('changeSearchResultActiveLotKeyEnquiry', this.index)
                this.$store.dispatch('setStockCarAlertDetails', {stockCarAlertModalStatus: true, stockCarAlertMessage: null, carObj: {lot: this.lot, user: this.user, counterOffer:false}, isResponse: false})
            },
            counterOffer(){
                this.$store.dispatch('changeSearchResultActiveLotKeyEnquiry', this.index)
                this.$store.dispatch('setStockCarAlertDetails', {stockCarAlertModalStatus: true, stockCarAlertMessage: null, carObj: {lot: this.lot, user: this.user, counterOffer:true}, isResponse: false})
            },
            openGallery() {
                var gallery = this.lot.images.split('#');
                gallery.unshift(this.lot.auction_list)
                this.$store.dispatch('setResultGalleryItems', gallery)
                this.$store.dispatch('setResultGalleryOptions', { index: 0 })
                this.$store.dispatch('setResultGalleryStatus', true)
                this.$store.dispatch('setResultGalleryCar', this.lot)
            }
        },
        computed: {
            isVisited() {
                return this.$store.getters.checkIfLotIsVisitedStock(this.lot.lot_id)
            },
            hasEnquiry() {
                return this.lot.enquiry.length;
            }
        }
    }
</script>

<style scoped>
    td {
        font-size: 12px;
    }
    .picture-td {
        width: 65px;
    }
    .link {
        cursor: pointer;
    }
    .image {
        cursor: pointer;
    }
    .is-visited {
        background: #a9ddff !important;
    }
    .has-bid {
        background: rgba(236, 209, 100, 0.57)!important;
    }

</style>



// WEBPACK FOOTER //
// src/components/StockCars/StockCarsTableRow.vue